import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import ArticleInvestorsComponent from '../../ManageArticles/article-investors';

function InvestorsDetailModal(props) {
  const { isOpen, onClose, articleId } = props;

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        maxW={'986px'}
        maxH={{ base: '80vh', md: '90vh' }}
        p={'24px'}
        bgColor={'#FAFAFA'}
        rounded={'12px'}
      >
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">Article Investors</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              alt=""
              onClick={onClose}
            />
          </div>
        </ModalHeader>
        <ModalBody p={0} overflowY={'scroll'}>
          <ArticleInvestorsComponent articleId={articleId} />
        </ModalBody>
        <ModalFooter w="100%" p={0}></ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default InvestorsDetailModal;
